import "@styles/layout.css";
import { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthContext } from "@contexts/AuthContext";

import NotifyPop from "@common-components/NotifyPop/NotifyPop";

const AuthRequiredOptionPageLayout = () => {
  const { currentUser } = useContext(AuthContext);

  return !currentUser ? (
    <Navigate to={"/home/login"} />
  ) : (
    currentUser && (
      <div className="Layout__container">
        <Outlet />
        <NotifyPop />
      </div>
    )
  );
};

export default AuthRequiredOptionPageLayout;
